export default __webpack_public_path__ + "static/governance-bank-1eccf6a4e8e883f542762a2aa0f825e3.png";